/**
 * Shared time-grid utilities used across Atelier, Reception, and Disponibilités screens.
 */

/** Snap a decimal hour to the nearest grid increment */
export function snapToGrid(hour: number, snapUnit: number): number {
  return Math.round(hour / snapUnit) * snapUnit;
}

/** Format a decimal hour as "8h00", "9h15", etc. */
export function formatTime(h: number): string {
  const hours = Math.floor(h);
  const mins = Math.round((h - hours) * 60);
  return `${hours}h${mins.toString().padStart(2, "0")}`;
}

/** Convert decimal hour to HH:MM string (e.g. 8.25 → "08:15") */
export function hourToTimeStr(h: number): string {
  const hours = Math.floor(h);
  const mins = Math.round((h - hours) * 60);
  return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
}

/** Convert HH:MM string to decimal hour (e.g. "08:15" → 8.25) */
export function timeStrToHour(s: string): number {
  const [h, m] = s.split(":").map(Number);
  return h + m / 60;
}
